export const APP_NAME: string = "omt";
